import { render, staticRenderFns } from "./CarrinhoCompras.vue?vue&type=template&id=019e72a2&scoped=true"
import script from "./CarrinhoCompras.vue?vue&type=script&lang=js"
export * from "./CarrinhoCompras.vue?vue&type=script&lang=js"
import style0 from "./CarrinhoCompras.vue?vue&type=style&index=0&id=019e72a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e72a2",
  null
  
)

export default component.exports